export enum RESPONSE_FORGOT_RUT {
    CANTIDAD_REINTENTOS_SUPERADA = 1,
    FORMATO_RUT_INCORRECTO = 2,
    RUT_NO_CORRESPONDE = 3,
    RUT_INVALIDO = 4,
    TELEFONO_NO_CORRESPONDE = 5,
    SMS_ENVIADO = 6,
}